<template>
  <div class="safety-mode-bottom-bar">
    <div class="timer">
      <div v-if="pausedAt" class="label f8 -paused">{{ $t('Paused') }}</div>
      <div v-else class="label f8 -playing">{{ $t('Now Playing') }}</div>
      <span class="f4">{{ time }}</span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment-timezone';
import DateHelper from '@/core/shared/helpers/DateHelper';

@Component({
  props: {
    endTime: {
      type: String,
      required: true,
    },
    pausedAt: {
      type: String,
    },
    currentTime: {
      type: String,
      required: true,
    },
  },
})
export default class BookingDetailSafetyMode extends Vue {
  get time () {
    const diff = moment(this.endTime).diff(moment(this.currentTime));
    return DateHelper.formatMillisecondsToHMS(diff);
  }
}
</script>

<style scoped lang="postcss">
@import 'core/shared/styles';

.safety-mode-bottom-bar {
  padding: var(--spacingSm);

  & .timer {
    text-align: right;
    margin-left: var(--spacingMd);

    & .label {
      margin-bottom: var(--spacingXS);

      &.-playing {
        color: var(--colorSuccessFlat);
      }

      &.-paused {
        color: var(--colorSBRedFlat);
      }
    }
  }
}
</style>
